module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.deriveClass
  }, [_c('label', {
    staticClass: "field-title",
    class: {
      'on': _vm.internalValue || _vm.focussed || _vm.placeholder
    }
  }, [_vm._v("\n    " + _vm._s(_vm.displayLabel) + "\n  ")]), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "maxlength": _vm.maxlength,
      "id": _vm.id,
      "type": "text",
      "readonly": _vm.readonly,
      "required": _vm.required,
      "placeholder": _vm.placeholderContent
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "keyup": function($event) {
        _vm.keyup($event)
      },
      "input": function($event) {
        _vm.input($event)
      },
      "focus": function($event) {
        _vm.focus($event)
      },
      "blur": function($event) {
        _vm.blur($event)
      }
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.config.help_text) ? [_c('span', {
    staticClass: "help-text",
    on: {
      "click": function($event) {
        _vm.showHelpText()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/src/assets/img/i.png"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpTextShown),
      expression: "helpTextShown"
    }],
    ref: "helpText",
    staticClass: "help-text-content",
    class: {
      'show': _vm.helpTextShown
    }
  }, [_vm._v("\n      " + _vm._s(_vm.config.help_text) + "\n    ")])] : _vm._e(), _vm._v(" "), (!!_vm.errorMessage && !_vm.focussed) ? _c('p', {
    staticClass: "error-msg"
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d00892d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextField.vue
// module id = 75
// module chunks = 0